import React, { StatelessComponent } from "react";
import SpecsFeaturesAccordion from "../SpecsFeatures/SpecsFeaturesAccordion";
import ServiceDetailsStore from './ServiceDetailsStore';
import { observer, inject } from "mobx-react";

export interface ServiceDetailsProps {
}

interface InjectedProps extends ServiceDetailsProps {
  serviceDetailsStore: ServiceDetailsStore;
}

const ServiceDetails: StatelessComponent<ServiceDetailsProps> = (props: ServiceDetailsProps) => {

  const { serviceDetailsStore } = props as InjectedProps;
  const { operationDetails : { isDetailsExist, isFetching, standardQuote, performance, safety, retainedValue },
    vehicleMetadata : { model, vin}} = serviceDetailsStore;
  let nextWeek = new Date();
  nextWeek.setDate(nextWeek.getDate() + 7);

  return (isDetailsExist && !isFetching &&
    <div className="serviceDetails">
      <h2 className="h2 text-center">Standard Scheduled Service Quote</h2>
      <div>
        <div>
        Thank you, we have found the following vehicle based on the provided details:
        </div>
      </div>
      <div><div className="h5">Model:</div> {model}</div>
      <div><div className="h5">VIN:</div> {vin}</div>
      <div><div className="h5">Standard Scheduled Service Quote (incl. GST):</div> ${standardQuote}</div>
      <div>
        {`The Standard Scheduled Service Quote represents the maximum price you will be charged \
          by participating Subaru Retailers for the quoted Standard Scheduled Service and includes GST. \
          Standard Scheduled Service Quote is ${nextWeek.toDateString()}. Prices are subject to change \
          after this date without notice. For a list of participating Subaru Retailers click `}
          <a href="/retailers?department=Service&option=Capped%2520Price%2520Servicing">here</a>{`. \
          Terms and conditions apply. To view full terms and conditions click `}
          <a href="http://subaru-com-au-3.s3.amazonaws.com/Transparent_Service_Pricing_Program_Terms__Conditions_April_2015.pdf">here</a>.
      </div>
      <div><div className="h5">Full Service Interval Details</div></div>
      <div>
        The difference is in our DNA.
      </div>
      <div>
        {
          `By choosing Subaru to service your car, you're not only guaranteed to benefit from our passion, experience \
          and craftsmanship - you'll also benefit from 100% transparency. Why? Because everything we do enhances your \
          vehicle's ongoing Performance, Safety and Retained Value. Take a look...`
        }
      </div>
      
      <SpecsFeaturesAccordion key='seviceGroup0' >
        <h4 className="specs__groupTitle">Performance</h4>
        {
          performance.map((item, i) => {
            return (
                <div className="specs__groupRows" key={i}>
                  <div>{item.itemDescription}</div>
              </div>
            );
          })
        }
      </SpecsFeaturesAccordion>
      <SpecsFeaturesAccordion key='seviceGroup1' >
        <h4 className="specs__groupTitle">Safety</h4>
        {
          safety.map((item, i) => {
            return (
                <div className="specs__groupRows" key={i}>
                  <div>{item.itemDescription}</div>
              </div>
            );
          })
        }
      </SpecsFeaturesAccordion>
      <SpecsFeaturesAccordion key='seviceGroup2' >

        <h4 className="specs__groupTitle">Retained Value</h4>
        {
          retainedValue.map((item, i) => {
            return (
                <div className="specs__groupRows" key={i}>
                  <div>{item.itemDescription}</div>
              </div>
            );
          })
        }
      </SpecsFeaturesAccordion>
      <div className="col-xs-12 text-center">
        <a id="service-details-book-a-service" href="/service-booking" className="btn bottom-toolbar">Book a Service</a>
        <a id="service-details-find-a-retailer" href="/retailers?department=Service&amp;option=Capped%20Price%20Servicing" className="btn bottom-toolbar">Find a Retailer</a>
      </div>
    </div>
  );
};

export default inject("serviceDetailsStore")(observer(ServiceDetails));
